import React from 'react';
import styles from 'componets/page-not-found/index.module.scss';
import { useHistory } from 'react-router-dom';

const PageNotFound = () => {
  const history = useHistory();

  return (
    <div className={styles.container}>
      <div className={styles.title}>企業方案</div>
      <div className={styles.subTitle}>找不到您的頁面，請返回後重試。</div>
      <div
        className={styles.backButton}
        onClick={() => {
          history.replace('/');
        }}
      >
        返回
      </div>
    </div>
  );
};

export default PageNotFound;
